<template>
  <div :class="classList">
    <div class="o-modal__box">
      <v-loading-spinner v-if="loading"></v-loading-spinner>
      <a class="o-modal__box__close" href="#" tabindex="0" @click.prevent="close">
        <icon name="times" />
      </a>
      <slot name="header" />
      <slot name="content" />
    </div>
    <div class="o-modal__overlay"></div>
  </div>
</template>

<script>
import { VLoadingSpinner } from '../atoms';
import addSlotClasses from '../mixins/slotClassAddition';

export default {
  name: 'v-modal',
  components: {
    VLoadingSpinner,
  },
  mixins: [addSlotClasses],
  props: {
    name: {
      type: [String],
      required: true,
    },
    size: [String],
    loading: [Boolean],
  },
  data() {
    return {
      headerClass: 'o-modal__box__header',
      contentClass: 'o-modal__box__content',
      active: false,
    };
  },
  created() {
    this.$bus.$on('toggleModal', ({ name, active }) => {
      if (name === this.name) {
        this.active = active;
        this.$emit('onOpen');
        this.$store.dispatch('modals/MODAL_HISTORY', name);
      } else {
        this.active = false;
        this.$emit('onClose');
      }
    });
    this.$bus.$on('closeModal', () => {
      this.active = false;
      this.$emit('onClose');
    });
  },
  mounted() {
    this.addSlotClasses();
  },
  computed: {
    classList() {
      const { active, size } = this;
      return {
        'o-modal': true,
        'o-modal--active': active,
        [`o-modal--${size}`]: size,
      };
    },
  },
  methods: {
    close() {
      this.$emit('onClose');
      this.$bus.$emit('closeModal');
      this.$bus.$emit('hideGlobalMessage');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.o-modal';

  #{$parent} {
    //elements
    &__box {
      background: #fff;
      position: fixed;
      top: 45%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0) scale(0.8);
      border-radius: 3px;
      opacity: 0;
      visibility: hidden;
      width: 650px;
      max-width: calc(100% - 30px);
      max-height: calc(100% - 30px);
      box-shadow: 0 0 20px 2px #222;
      transition: opacity .25s ease-in-out, top .25s ease-in-out, transform .15s ease-in-out;
      //elements
      &__header {
        padding: $spacing-base;
        border-bottom: 1px solid $color-border;
        margin-bottom: 0;
      }
      &__content {
        padding: $spacing-base;
        max-height: calc(100vh - 90px);
        overflow-y: scroll;
      }
      &__close {
        z-index: 3;
        line-height: 0;
        background: #fff;
        border-radius: 30px;
        position: absolute;
        right: -$spacing-small;
        top: -$spacing-small;
        padding: $spacing-xs;
        border: 3px solid $color-error;
        &:hover {
          background: $color-error;
          svg {
            color: #fff;
          }
        }
        svg {
          height: 12px;
          width: 12px;
          color: $color-error;
        }
      }
    }
    //modifiers
    &--active {
      #{$parent}__box {
        opacity: 1;
        top: 50%;
        visibility: visible;
        transform: translate3d(-50%, -50%, 0) scale(1);
        z-index: 800;
      }
      #{$parent}__overlay {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        width: 100%;
        height: 100%;
        z-index: 700;
      }
    }
    &--small {
      #{$parent}__box {
        width: 450px;
      }
    }
  }
</style>
